export default {
    title: '提示',
    show: false,
    text: '',
    buttonText: '确定',
    align: 'center',
    callback: '',
    closeBtn: true
};



// WEBPACK FOOTER //
// ./src/ui/alert/store/state.js